import { render, staticRenderFns } from "./EliseStatistics.vue?vue&type=template&id=dd8dff32&"
import script from "./EliseStatistics.vue?vue&type=script&lang=ts&"
export * from "./EliseStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports